import y from "../../../../public/projects/pridepurple/projects/y.jpg";
import s from "../../../../public/projects/pridepurple/logo/s.png";
import evergreen from "../../../../public/projects/pridepurple/projects/ev.jpg"

// parktitan
import overviewImageparktitan from "../../../../public/projects/pridepurple/parktitan/overview/1.webp";
import bannerDesktopImageparktitan from "../../../../public/projects/pridepurple/parktitan/banner/1.webp";
import bannerMobileImageparktitan from "../../../../public/projects/pridepurple/parktitan/banner/2.webp";
import Locationparktitan from "../../../../public/projects/pridepurple/parktitan/location/1.webp";
import Hightlightsparktitan from "../../../../public/projects/pridepurple/parktitan/highlights/1.webp";
import floorplan1parktitan from "../../../../public/projects/pridepurple/parktitan/floorplan/1.webp";
import floorplan2parktitan from "../../../../public/projects/pridepurple/parktitan/floorplan/2.webp";
import floorplan3parktitan from "../../../../public/projects/pridepurple/parktitan/floorplan/3.webp";
import floorplan4parktitan from "../../../../public/projects/pridepurple/parktitan/floorplan/4.webp";
import floorplan5parktitan from "../../../../public/projects/pridepurple/parktitan/floorplan/5.webp";
import locationiconparktitan from "../../../../public/projects/pridepurple/parktitan/overview/l.png";
import caliconparktitan from "../../../../public/projects/pridepurple/parktitan/overview/c.png";
import newlaunchiconparktitan from "../../../../public/projects/pridepurple/parktitan/overview/n.png";
import gallery1parktitan from "../../../../public/projects/pridepurple/parktitan/gallery/1.webp";
import gallery2parktitan from "../../../../public/projects/pridepurple/parktitan/gallery/2.webp";
import gallery3parktitan from "../../../../public/projects/pridepurple/parktitan/gallery/3.webp";
import gallery4parktitan from "../../../../public/projects/pridepurple/parktitan/gallery/4.webp";
import gallery5parktitan from "../../../../public/projects/pridepurple/parktitan/gallery/5.webp";

// projecttwo
import overviewImageprojecttwo from "../../../../public/projects/pridepurple/projecttwo/overview/1.webp";
import bannerDesktopImageprojecttwo from "../../../../public/projects/pridepurple/projecttwo/banner/1.webp";
import bannerMobileImageprojecttwo from "../../../../public/projects/pridepurple/projecttwo/banner/2.webp";
import Locationprojecttwo from "../../../../public/projects/pridepurple/projecttwo/location/1.webp";
import Hightlightsprojecttwo from "../../../../public/projects/pridepurple/projecttwo/highlights/1.webp";
import floorplan1projecttwo from "../../../../public/projects/pridepurple/projecttwo/floorplan/1.webp";
import floorplan2projecttwo from "../../../../public/projects/pridepurple/projecttwo/floorplan/2.webp";
import floorplan3projecttwo from "../../../../public/projects/pridepurple/projecttwo/floorplan/3.webp";
import floorplan4projecttwo from "../../../../public/projects/pridepurple/projecttwo/floorplan/4.webp";
import floorplan5projecttwo from "../../../../public/projects/pridepurple/projecttwo/floorplan/5.webp";
import locationiconprojecttwo from "../../../../public/projects/pridepurple/projecttwo/overview/l.png";
import caliconprojecttwo from "../../../../public/projects/pridepurple/projecttwo/overview/c.png";
import newlaunchiconprojecttwo from "../../../../public/projects/pridepurple/projecttwo/overview/n.png";
import gallery1projecttwo from "../../../../public/projects/pridepurple/projecttwo/gallery/1.webp";
import gallery2projecttwo from "../../../../public/projects/pridepurple/projecttwo/gallery/2.webp";
import gallery3projecttwo from "../../../../public/projects/pridepurple/projecttwo/gallery/3.webp";
import gallery4projecttwo from "../../../../public/projects/pridepurple/projecttwo/gallery/4.webp";
import gallery5projecttwo from "../../../../public/projects/pridepurple/projecttwo/gallery/5.webp";

// projectthree
import overviewImageprojectthree from "../../../../public/projects/pridepurple/projectthree/overview/1.webp";
import bannerDesktopImageprojectthree from "../../../../public/projects/pridepurple/projectthree/banner/1.webp";
import bannerMobileImageprojectthree from "../../../../public/projects/pridepurple/projectthree/banner/2.webp";
import Locationprojectthree from "../../../../public/projects/pridepurple/projectthree/location/1.webp";
import Hightlightsprojectthree from "../../../../public/projects/pridepurple/projectthree/highlights/1.webp";
import floorplan1projectthree from "../../../../public/projects/pridepurple/projectthree/floorplan/1.webp";
import floorplan2projectthree from "../../../../public/projects/pridepurple/projectthree/floorplan/2.webp";
import floorplan3projectthree from "../../../../public/projects/pridepurple/projectthree/floorplan/3.webp";
import floorplan4projectthree from "../../../../public/projects/pridepurple/projectthree/floorplan/4.webp";
import floorplan5projectthree from "../../../../public/projects/pridepurple/projectthree/floorplan/5.webp";
import locationiconprojectthree from "../../../../public/projects/pridepurple/projectthree/overview/l.png";
import caliconprojectthree from "../../../../public/projects/pridepurple/projectthree/overview/c.png";
import newlaunchiconprojectthree from "../../../../public/projects/pridepurple/projectthree/overview/n.png";
import gallery1projectthree from "../../../../public/projects/pridepurple/projectthree/gallery/1.webp";
import gallery2projectthree from "../../../../public/projects/pridepurple/projectthree/gallery/2.webp";
import gallery3projectthree from "../../../../public/projects/pridepurple/projectthree/gallery/3.webp";
import gallery4projectthree from "../../../../public/projects/pridepurple/projectthree/gallery/4.webp";
import gallery5projectthree from "../../../../public/projects/pridepurple/projectthree/gallery/5.webp";

// projectfour
import overviewImageprojectfour from "../../../../public/projects/pridepurple/projectfour/overview/1.webp";
import bannerDesktopImageprojectfour from "../../../../public/projects/pridepurple/projectfour/banner/1.webp";
import bannerMobileImageprojectfour from "../../../../public/projects/pridepurple/projectfour/banner/2.webp";
import Locationprojectfour from "../../../../public/projects/pridepurple/projectfour/location/1.webp";
import Hightlightsprojectfour from "../../../../public/projects/pridepurple/projectfour/highlights/1.webp";
import floorplan1projectfour from "../../../../public/projects/pridepurple/projectfour/floorplan/1.webp";
import floorplan2projectfour from "../../../../public/projects/pridepurple/projectfour/floorplan/2.webp";
import floorplan3projectfour from "../../../../public/projects/pridepurple/projectfour/floorplan/3.webp";
import floorplan4projectfour from "../../../../public/projects/pridepurple/projectfour/floorplan/4.webp";
import floorplan5projectfour from "../../../../public/projects/pridepurple/projectfour/floorplan/5.webp";
import locationiconprojectfour from "../../../../public/projects/pridepurple/projectfour/overview/l.png";
import caliconprojectfour from "../../../../public/projects/pridepurple/projectfour/overview/c.png";
import newlaunchiconprojectfour from "../../../../public/projects/pridepurple/projectfour/overview/n.png";
import gallery1projectfour from "../../../../public/projects/pridepurple/projectfour/gallery/1.webp";
import gallery2projectfour from "../../../../public/projects/pridepurple/projectfour/gallery/2.webp";
import gallery3projectfour from "../../../../public/projects/pridepurple/projectfour/gallery/3.webp";
import gallery4projectfour from "../../../../public/projects/pridepurple/projectfour/gallery/4.webp";
import gallery5projectfour from "../../../../public/projects/pridepurple/projectfour/gallery/5.webp";

// projectfive
import overviewImageprojectfive from "../../../../public/projects/pridepurple/projectfive/overview/1.webp";
import bannerDesktopImageprojectfive from "../../../../public/projects/pridepurple/projectfive/banner/1.webp";
import bannerMobileImageprojectfive from "../../../../public/projects/pridepurple/projectfive/banner/2.webp";
import Locationprojectfive from "../../../../public/projects/pridepurple/projectfive/location/1.webp";
import Hightlightsprojectfive from "../../../../public/projects/pridepurple/projectfive/highlights/1.webp";
import floorplan1projectfive from "../../../../public/projects/pridepurple/projectfive/floorplan/1.webp";
import floorplan2projectfive from "../../../../public/projects/pridepurple/projectfive/floorplan/2.webp";
import floorplan3projectfive from "../../../../public/projects/pridepurple/projectfive/floorplan/3.webp";
import floorplan4projectfive from "../../../../public/projects/pridepurple/projectfive/floorplan/4.webp";
import floorplan5projectfive from "../../../../public/projects/pridepurple/projectfive/floorplan/5.webp";
import locationiconprojectfive from "../../../../public/projects/pridepurple/projectfive/overview/l.png";
import caliconprojectfive from "../../../../public/projects/pridepurple/projectfive/overview/c.png";
import newlaunchiconprojectfive from "../../../../public/projects/pridepurple/projectfive/overview/n.png";
import gallery1projectfive from "../../../../public/projects/pridepurple/projectfive/gallery/1.webp";
import gallery2projectfive from "../../../../public/projects/pridepurple/projectfive/gallery/2.webp";
import gallery3projectfive from "../../../../public/projects/pridepurple/projectfive/gallery/3.webp";
import gallery4projectfive from "../../../../public/projects/pridepurple/projectfive/gallery/4.webp";
import gallery5projectfive from "../../../../public/projects/pridepurple/projectfive/gallery/5.webp";

// projectsix
import overviewImageprojectsix from "../../../../public/projects/pridepurple/projectsix/overview/1.webp";
import bannerDesktopImageprojectsix from "../../../../public/projects/pridepurple/projectsix/banner/1.webp";
import bannerMobileImageprojectsix from "../../../../public/projects/pridepurple/projectsix/banner/2.webp";
import Locationprojectsix from "../../../../public/projects/pridepurple/projectsix/location/1.webp";
import Hightlightsprojectsix from "../../../../public/projects/pridepurple/projectsix/highlights/1.webp";
import floorplan1projectsix from "../../../../public/projects/pridepurple/projectsix/floorplan/1.webp";
import floorplan2projectsix from "../../../../public/projects/pridepurple/projectsix/floorplan/2.webp";
import floorplan3projectsix from "../../../../public/projects/pridepurple/projectsix/floorplan/3.webp";
import floorplan4projectsix from "../../../../public/projects/pridepurple/projectsix/floorplan/4.webp";
import floorplan5projectsix from "../../../../public/projects/pridepurple/projectsix/floorplan/5.webp";
import locationiconprojectsix from "../../../../public/projects/pridepurple/projectsix/overview/l.png";
import caliconprojectsix from "../../../../public/projects/pridepurple/projectsix/overview/c.png";
import newlaunchiconprojectsix from "../../../../public/projects/pridepurple/projectsix/overview/n.png";
import gallery1projectsix from "../../../../public/projects/pridepurple/projectsix/gallery/1.webp";
import gallery2projectsix from "../../../../public/projects/pridepurple/projectsix/gallery/2.webp";
import gallery3projectsix from "../../../../public/projects/pridepurple/projectsix/gallery/3.webp";
import gallery4projectsix from "../../../../public/projects/pridepurple/projectsix/gallery/4.webp";
import gallery5projectsix from "../../../../public/projects/pridepurple/projectsix/gallery/5.webp";

// projectseven
import overviewImageprojectseven from "../../../../public/projects/pridepurple/projectseven/overview/1.webp";
import bannerDesktopImageprojectseven from "../../../../public/projects/pridepurple/projectseven/banner/1.webp";
import bannerMobileImageprojectseven from "../../../../public/projects/pridepurple/projectseven/banner/2.webp";
import Locationprojectseven from "../../../../public/projects/pridepurple/projectseven/location/1.webp";
import Hightlightsprojectseven from "../../../../public/projects/pridepurple/projectseven/highlights/1.webp";
import floorplan1projectseven from "../../../../public/projects/pridepurple/projectseven/floorplan/1.webp";
import floorplan2projectseven from "../../../../public/projects/pridepurple/projectseven/floorplan/2.webp";
import floorplan3projectseven from "../../../../public/projects/pridepurple/projectseven/floorplan/3.webp";
import floorplan4projectseven from "../../../../public/projects/pridepurple/projectseven/floorplan/4.webp";
import floorplan5projectseven from "../../../../public/projects/pridepurple/projectseven/floorplan/5.webp";
import locationiconprojectseven from "../../../../public/projects/pridepurple/projectseven/overview/l.png";
import caliconprojectseven from "../../../../public/projects/pridepurple/projectseven/overview/c.png";
import newlaunchiconprojectseven from "../../../../public/projects/pridepurple/projectseven/overview/n.png";
import gallery1projectseven from "../../../../public/projects/pridepurple/projectseven/gallery/1.webp";
import gallery2projectseven from "../../../../public/projects/pridepurple/projectseven/gallery/2.webp";
import gallery3projectseven from "../../../../public/projects/pridepurple/projectseven/gallery/3.webp";
import gallery4projectseven from "../../../../public/projects/pridepurple/projectseven/gallery/4.webp";
import gallery5projectseven from "../../../../public/projects/pridepurple/projectseven/gallery/5.webp";

// projecteight
import overviewImageprojecteight from "../../../../public/projects/pridepurple/projecteight/overview/1.webp";
import bannerDesktopImageprojecteight from "../../../../public/projects/pridepurple/projecteight/banner/1.webp";
import bannerMobileImageprojecteight from "../../../../public/projects/pridepurple/projecteight/banner/2.webp";
import Locationprojecteight from "../../../../public/projects/pridepurple/projecteight/location/1.webp";
import Hightlightsprojecteight from "../../../../public/projects/pridepurple/projecteight/highlights/1.webp";
import floorplan1projecteight from "../../../../public/projects/pridepurple/projecteight/floorplan/1.webp";
import floorplan2projecteight from "../../../../public/projects/pridepurple/projecteight/floorplan/2.webp";
import floorplan3projecteight from "../../../../public/projects/pridepurple/projecteight/floorplan/3.webp";
import floorplan4projecteight from "../../../../public/projects/pridepurple/projecteight/floorplan/4.webp";
import floorplan5projecteight from "../../../../public/projects/pridepurple/projecteight/floorplan/5.webp";
import locationiconprojecteight from "../../../../public/projects/pridepurple/projecteight/overview/l.png";
import caliconprojecteight from "../../../../public/projects/pridepurple/projecteight/overview/c.png";
import newlaunchiconprojecteight from "../../../../public/projects/pridepurple/projecteight/overview/n.png";
import gallery1projecteight from "../../../../public/projects/pridepurple/projecteight/gallery/1.webp";
import gallery2projecteight from "../../../../public/projects/pridepurple/projecteight/gallery/2.webp";
import gallery3projecteight from "../../../../public/projects/pridepurple/projecteight/gallery/3.webp";
import gallery4projecteight from "../../../../public/projects/pridepurple/projecteight/gallery/4.webp";
import gallery5projecteight from "../../../../public/projects/pridepurple/projecteight/gallery/5.webp";

// projectnine
import overviewImageprojectnine from "../../../../public/projects/pridepurple/projectnine/overview/1.webp";
import bannerDesktopImageprojectnine from "../../../../public/projects/pridepurple/projectnine/banner/1.webp";
import bannerMobileImageprojectnine from "../../../../public/projects/pridepurple/projectnine/banner/2.webp";
import Locationprojectnine from "../../../../public/projects/pridepurple/projectnine/location/1.webp";
import Hightlightsprojectnine from "../../../../public/projects/pridepurple/projectnine/highlights/1.webp";
import floorplan1projectnine from "../../../../public/projects/pridepurple/projectnine/floorplan/1.webp";
import floorplan2projectnine from "../../../../public/projects/pridepurple/projectnine/floorplan/2.webp";
import floorplan3projectnine from "../../../../public/projects/pridepurple/projectnine/floorplan/3.webp";
import floorplan4projectnine from "../../../../public/projects/pridepurple/projectnine/floorplan/4.webp";
import floorplan5projectnine from "../../../../public/projects/pridepurple/projectnine/floorplan/5.webp";
import locationiconprojectnine from "../../../../public/projects/pridepurple/projectnine/overview/l.png";
import caliconprojectnine from "../../../../public/projects/pridepurple/projectnine/overview/c.png";
import newlaunchiconprojectnine from "../../../../public/projects/pridepurple/projectnine/overview/n.png";
import gallery1projectnine from "../../../../public/projects/pridepurple/projectnine/gallery/1.webp";
import gallery2projectnine from "../../../../public/projects/pridepurple/projectnine/gallery/2.webp";
import gallery3projectnine from "../../../../public/projects/pridepurple/projectnine/gallery/3.webp";
import gallery4projectnine from "../../../../public/projects/pridepurple/projectnine/gallery/4.webp";
import gallery5projectnine from "../../../../public/projects/pridepurple/projectnine/gallery/5.webp";

// projectten
import overviewImageprojectten from "../../../../public/projects/pridepurple/projectten/overview/1.webp";
import bannerDesktopImageprojectten from "../../../../public/projects/pridepurple/projectten/banner/1.webp";
import bannerMobileImageprojectten from "../../../../public/projects/pridepurple/projectten/banner/2.webp";
import Locationprojectten from "../../../../public/projects/pridepurple/projectten/location/1.webp";
import Hightlightsprojectten from "../../../../public/projects/pridepurple/projectten/highlights/1.webp";
import floorplan1projectten from "../../../../public/projects/pridepurple/projectten/floorplan/1.webp";
import floorplan2projectten from "../../../../public/projects/pridepurple/projectten/floorplan/2.webp";
import floorplan3projectten from "../../../../public/projects/pridepurple/projectten/floorplan/3.webp";
import floorplan4projectten from "../../../../public/projects/pridepurple/projectten/floorplan/4.webp";
import floorplan5projectten from "../../../../public/projects/pridepurple/projectten/floorplan/5.webp";
import locationiconprojectten from "../../../../public/projects/pridepurple/projectten/overview/l.png";
import caliconprojectten from "../../../../public/projects/pridepurple/projectten/overview/c.png";
import newlaunchiconprojectten from "../../../../public/projects/pridepurple/projectten/overview/n.png";
import gallery1projectten from "../../../../public/projects/pridepurple/projectten/gallery/1.webp";
import gallery2projectten from "../../../../public/projects/pridepurple/projectten/gallery/2.webp";
import gallery3projectten from "../../../../public/projects/pridepurple/projectten/gallery/3.webp";
import gallery4projectten from "../../../../public/projects/pridepurple/projectten/gallery/4.webp";
import gallery5projectten from "../../../../public/projects/pridepurple/projectten/gallery/5.webp";



export const developerpridepurple = {
  properties: [
    {
      name: "pridepurple The Trillion",
      image: bannerMobileImageparktitan,
      price: " 6.14 Crore Onwards",
      state: " Gurugram",
      developer: "pridepurple",
      location: "Sector 48, Gurugram",
      projectlocation: "Gurugram",
      bed: "3,4 BHK Apartments",
      size: "3000-3600 sq.ft.",
      url: `/pridepurple-trillion`,
      form: {
        source_id: 11,
        api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
        api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
        sub_source_id: 130,
        builder_id: `103`,
        project_id: `477`,
        subject: "pridepurple The Trillion",
        to_email: "jatin.rohilla@propertystation.in",
      }
    },
  ],
};
export const Headers = {
  logo: s,
  data: {
    experience: "2006",
  },
  about: `pridepurple, a 100% FDI funded real-estate developer, backed by pridepurple Holdings Pte. Ltd., Singapore, the real estate investing division of the AT Holdings group of companies. AT Capital, headquartered in Singapore, was established with the aim of capitalizing on global opportunities within both established and emerging sectors.`,
};


export const projectspridepurple = {

  parktitan: {
    bannerdata: {
      bannerDesktopImage: bannerDesktopImageparktitan,
      bannerMobileImage: bannerMobileImageparktitan,
      textOverlay: "",
      data: {
        title: "Park Titan",
        subtitle: " Hinjewadi, Pune",
        starting_price: "₹ 76.27 L Onwards  ",
        payment_plan: "CLP",
        rerano: "-",
        status: "Under Construction"
      }
    },

    overview: {
      heading: "Park Titan Hinjewadi, Pune",
      description: [
        "Park Titan Hinjewadi Pune is a great place to live for those who want modern homes with excellent facilities and good transport links. If you're looking for 2 BHK flats in Pune Hinjewadi, Park Titan provides comfort and convenience, making it perfect for families and workers. This large project by Pride Purple Group is located on the Hinjawadi-Marunji Link Road, making it easy to reach major IT areas, schools, hospitals, and shopping centers.",
        "The project has roomy 2 BHK flats, with sizes between 726 to 789 sq. ft., designed to make the best use of space and light. Park Titan covers 18 acres, with 18 towers and almost 7 acres of gardens and amenities, giving residents a peaceful green area. The flats come with many modern features like a clubhouse, swimming pools, gym, yoga area, cycling track, and an indoor badminton court, catering to all ",
        "A special feature of Park Titan is its focus on overall well-being. The project partners with well-known academies like M S Dhoni Cricket Academy and Prakash Padukone Badminton Academy, providing residents with sports and skills training close to home. It also includes advanced home technology, EV charging stations, video door phones, and strong security, making it very modern.",
        "For anyone looking to buy flats in Pune Hinjewadi, Park Titan offers good prices and various options to fit different budgets. The project is RERA-approved, ensuring trust for buyers. Whether you are buying your first home or looking for a property to rent out, the demand for 2 BHK flats in Pune Hinjewadi is high because of the area's fast growth and closeness to important business areas.",
      ],
      keywordLinks: {
      },
      image: overviewImageparktitan,
      buttonLabel: "Enquire Now",
      stripdata: [
        {
          iconClass: locationiconparktitan,
          title: "₹ 76.24 L Onwards ",
          subtitle: "Starting Price",
        },
        {
          iconClass: caliconparktitan,
          title: "CLP",
          subtitle: "Payment Plan",
        },
        {
          iconClass: newlaunchiconparktitan,
          title: "Under Construction ",
          subtitle: "Status",
        },
      ],
    },

    pricing: {
      heading: "Pricing",
      table: [
        {
          type: "2 BHK ",
        area: " 608.05 - 815 sq.ft.",
        price: "₹ 92.23 L - 1.2 Cr Onwards",
          eoiAmount: "On Request",
        },
        {
          type: "3 BHK  ",
          area: "872.27 - 1225 sq.ft. ",
          price: "₹ 1.22 - 1.71 Cr Onwards",
          eoiAmount: "On Request",
        },
      ],
    },

    floor_plan: [
      {
        type: "2 BHK ",
        area: " 608.05 - 815 sq.ft.",
        price: "₹ 92.23 L - 1.2 Cr Onwards",
        image: floorplan1parktitan,
      },
      {
        type: "3 BHK  ",
        area: "872.27 - 1225 sq.ft. ",
        price: "₹ 1.22 - 1.71 Cr Onwards",
        image: floorplan2parktitan,
      }
    ],

    highlights: {
      images: Hightlightsparktitan,
      tagline: "Highlights",
      features: [
        "7 acres of open space with 70% green area.",
        "Landscaped area with steps.",
        "Swimming pool and a small pool for toddlers.",
        "Entrance area on the property.",
        "School bus stop available."
      ],
    },
    

    location: {
      image: Locationparktitan,
      data: [
        {
          airport: {
            distance_time: "25.3 Km",
            name: "Pune International Airport"
          },
          school: {
            distance_time: "4.5 Km",
            name: "Bliss International School"
          },
          railwayormetro: {
            distance_time: "11.7 Km",
            name: "Pimpri Metro Station"
          },
          hospital: {
            distance_time: "2.8 Km",
            name: "Sanjeevani Multispeciality Hospital"
          },
          mall: {
            distance_time: "3.3 Km",
            name: "Xion Mall"
          }
        }
      ]
    },
    

    gallery: {
      color: "#cd8c66",
      tagline: "Project Gallery",
      images: [
        { image: gallery1parktitan },
        { image: gallery2parktitan },
        { image: gallery3parktitan },
        { image: gallery4parktitan },
        { image: gallery5parktitan },
      ],
    },

    whatsapp: {
      title: "Property Station",
      subTitle: "Happy to Help You!",
      greetingText: "Hi there! \nHow can I help you?",
      ctaText: "Start Chat",
      whatsAppNumber: "7079429676",
      welcomeMessage:
        "Hi! I'm interested in Park Titan, kindly share more details.",
    },

    faq: [
      {
        question: "Who is the developer of Park Titan Hinjewadi Pune?",
        answer: "The project is developed by Pride Purple Group."
      },
      {
        question: "Where is Park Titan located?",
        answer: "Park Titan is located on the Hinjawadi-Marunji Link Road in Hinjewadi, Pune."
      },
      {
        question: "What types of flats are available at Park Titan?",
        answer: "Park Titan offers 2 BHK and 3 BHK apartments."
      },
      {
        question: "How many towers and floors does the project have?",
        answer: "The project comprises 18 towers, each with 23 storeys."
      },
      {
        question: "What are the key amenities available at Park Titan?",
        answer: "Amenities include a multi-storey clubhouse, swimming pools (semi-Olympic, kids, leisure)."
      },
      {
        question: "Are there any special facilities for children and families?",
        answer: "Yes, Park Titan features a crèche, kids’ play areas, tot lots, and a labyrinth."
      },
      {
        question: "Does Park Titan offer any business or work-from-home facilities?",
        answer: "Yes, the project includes a business centre, co-working spaces, meeting pods, and a cafeteria for residents."
      },
      {
        question: "Is the project RERA approved?",
        answer: "Yes, Park Titan is approved by Maharashtra RERA."
      },
      {
        question: "What are the security and smart home features?",
        answer: "The project offers premium home automation, video door phones, theft and electrical fault detection."
      },
      {
        question: "What are some nearby landmarks and conveniences?",
        answer: "Key landmarks near Park Titan include Sanjeevani Multispeciality Hospital and Xion Mall."
      }
    ],
    


    form_data: {
      api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
      api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
      source_id: 11,
      sub_source_id: 130,
      builder_id: `103`,
      project_id: `477`,
      subject: "Property Station enquiry", // Add or update the subject here
      to_email: "leads@gurugram-property.com",
    },
  },
  projecttwo: {
    bannerdata: {
      bannerDesktopImage: bannerDesktopImageprojecttwo,
      bannerMobileImage: bannerMobileImageprojecttwo,
      textOverlay: "",
      data: {
        title: "pridepurple The Trillion",
        subtitle: " Sector 48, Gurugram",
        starting_price: "₹ 6.14 Crore Onwards  ",
        payment_plan: "20:40:40",
        rerano: "GGM/911/643/2025/14",
        status: "New Launch"
      }
    },

    overview: {
      heading: "pridepurple The Trillion",
      description: [
        "pridepurple The Trillion in Gurgaon is a new luxury residential project that offers a stylish and comfortable lifestyle. This residential project is located in Sector 48, Golf Course Extension Road, this project is designed for people who want a modern home with top-class features. It is developed by pridepurple Developers, The Trillion brings a perfect mix of beautiful design, world-class amenities, and a prime location.",
        "The project offers spacious 3 BHK, 4 BHK apartments, and penthouses with smart layouts and premium interiors. Every home at pridepurple Trillion is made to give you more space, natural light, and a peaceful environment. High-quality materials, smart home features, and luxury fittings make each apartment truly special.",
        "Living at pridepurple Trillion Sector 48 Gurgaon means enjoying a lot of premium facilities. There is a modern clubhouse, swimming pool, gym, spa, private dining spaces, children’s play area, and beautiful green gardens. You also get 24x7 security, concierge services, and easy access to all daily needs.",
        "The location of pridepurple The Trillion is one of its biggest advantages. It is close to important offices, schools, hospitals, malls, and restaurants. Major roads like Golf Course Road, NH-8, and the Rapid Metro are nearby, making travel quick and easy.",
      ],
      keywordLinks: {
        "pridepurple": "/developers/pridepurple",
      },
      image: overviewImageprojecttwo,
      buttonLabel: "Enquire Now",
      stripdata: [
        {
          iconClass: locationiconprojecttwo,
          title: "₹ 6.14 Crore Onwards ",
          subtitle: "Starting Price",
        },
        {
          iconClass: caliconprojecttwo,
          title: "20:40:40",
          subtitle: "Payment Plan",
        },
        {
          iconClass: newlaunchiconprojecttwo,
          title: "New Launch ",
          subtitle: "Status",
        },
      ],
    },

    pricing: {
      heading: "Pricing",
      table: [
        {
          type: "3 BHK ",
          area: "3000 sq.ft.",
          price: "₹ 6.14 Cr",
          eoiAmount: "On Request",
        },
        {
          type: "4 BHK  ",
          area: "3600 sq.ft. ",
          price: "₹ 7.37 Cr",
          eoiAmount: "On Request",
        },
      ],
    },

    floor_plan: [
      {
        type: "3 BHK ",
        area: "3000 sq.ft.",
        price: "₹ 6.14 Cr",
        image: floorplan1projecttwo,
      },
      {
        type: "4 BHK  ",
        area: "3600 sq.ft. ",
        price: "₹ 7.37 Cr",
        image: floorplan2projecttwo,
      }
    ],

    highlights: {
      images: Hightlightsprojecttwo,
      tagline: "Highlights",
      features: [
        "540 EXCLUSIVE Units. ",
        "Over 80% of green space. ",
        "Stilt + 45 Storey Towers. ",
        "VRV / VRF Air-Conditioning & Modular Kitche. ",
        "Basement Entrance Lobby with Green Atrium. ",
        "Two Car Parkings Per Unit. ",
        "Over 1 lakh sq. ft. of amenities space. ",
      ],
    },

    location: {
      image: Locationprojecttwo,
      data: [
        {
          airport: {
            distance_time: "24 km",
            name: "IGI Airport"
          },
          school: {
            distance_time: "1 Km",
            name: "GD Goenka School"
          },
          railwayormetro: {
            distance_time: "6 Km",
            name: "Millennium City Centre Gurugram"
          },
          hospital: {
            distance_time: "1 Km",
            name: "Park Hospital"
          },
          mall: {
            distance_time: "7 Km",
            name: "Airia Mall"
          }
        }
      ]
    },

    gallery: {
      color: "#cd8c66",
      tagline: "Project Gallery",
      images: [
        { image: gallery1projecttwo },
        { image: gallery2projecttwo },
        { image: gallery3projecttwo },
        { image: gallery4projecttwo },
        { image: gallery5projecttwo },
      ],
    },

    whatsapp: {
      title: "Property Station",
      subTitle: "Happy to Help You!",
      greetingText: "Hi there! \nHow can I help you?",
      ctaText: "Start Chat",
      whatsAppNumber: "7079429676",
      welcomeMessage:
        "Hi! I'm interested in pridepurple The Trillion, kindly share more details.",
    },

    faq: [
      {
        question: "Where is pridepurple The Trillion located?",
        answer: `pridepurple The Trillion is located in Sector 48, Gurgaon, providing excellent connectivity to major business hubs and city landmarks.`,
      },
      {
        question: "What types of homes are available at pridepurple The Trillion?",
        answer: `pridepurple The Trillion offers spacious 3 BHK and 4 BHK luxury apartments designed for premium living.`,
      },
      {
        question: "What is the size range of apartments in pridepurple The Trillion?",
        answer: `The 3 BHK apartments are approximately 2850 sq. ft., and the 4 BHK apartments are around 3600 sq. ft.`,
      },
      {
        question: "What is the price range for apartments at pridepurple The Trillion?",
        answer: `Prices start from ₹6.14 Crores onwards, depending on the unit size, floor, and view.`,
      },
      {
        question: "Is the project RERA registered?",
        answer: `Yes, pridepurple The Trillion is RERA registered.`,
      },
      {
        question: "What is the possession status of pridepurple The Trillion?",
        answer: `The project is newly launched.`,
      },
      {
        question: "What amenities are offered at pridepurple The Trillion?",
        answer: `Amenities include a grand clubhouse, swimming pool, gym, spa, kids’ play area, jogging track, and landscaped gardens.`,
      },
      {
        question: "Who is the developer of pridepurple The Trillion?",
        answer: `pridepurple The Trillion is developed by pridepurple Developers, one of India's most trusted and reputed real estate developers, known for quality and innovation.`,
      },
      {
        question: "Is pridepurple The Trillion a good investment in Gurgaon?",
        answer: `Yes, with its prime location, luxury features, and strong brand reputation, pridepurple The Trillion is considered an excellent investment option in Gurgaon.`,
      },
      {
        question: "How is the connectivity from pridepurple The Trillion?",
        answer: `The project enjoys superb connectivity via Golf Course Extension Road and NH-8, offering easy access to major business centers and important city locations.`,
      }
    ],


    form_data: {
      api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
      api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
      source_id: 11,
      sub_source_id: 130,
      builder_id: `103`,
      project_id: `477`,
      subject: "Property Station enquiry", // Add or update the subject here
      to_email: "leads@gurugram-property.com",
    },
  },
  projectthree: {
    bannerdata: {
      bannerDesktopImage: bannerDesktopImageprojectthree,
      bannerMobileImage: bannerMobileImageprojectthree,
      textOverlay: "",
      data: {
        title: "pridepurple The Trillion",
        subtitle: " Sector 48, Gurugram",
        starting_price: "₹ 6.14 Crore Onwards  ",
        payment_plan: "20:40:40",
        rerano: "GGM/911/643/2025/14",
        status: "New Launch"
      }
    },

    overview: {
      heading: "pridepurple The Trillion",
      description: [
        "pridepurple The Trillion in Gurgaon is a new luxury residential project that offers a stylish and comfortable lifestyle. This residential project is located in Sector 48, Golf Course Extension Road, this project is designed for people who want a modern home with top-class features. It is developed by pridepurple Developers, The Trillion brings a perfect mix of beautiful design, world-class amenities, and a prime location.",
        "The project offers spacious 3 BHK, 4 BHK apartments, and penthouses with smart layouts and premium interiors. Every home at pridepurple Trillion is made to give you more space, natural light, and a peaceful environment. High-quality materials, smart home features, and luxury fittings make each apartment truly special.",
        "Living at pridepurple Trillion Sector 48 Gurgaon means enjoying a lot of premium facilities. There is a modern clubhouse, swimming pool, gym, spa, private dining spaces, children’s play area, and beautiful green gardens. You also get 24x7 security, concierge services, and easy access to all daily needs.",
        "The location of pridepurple The Trillion is one of its biggest advantages. It is close to important offices, schools, hospitals, malls, and restaurants. Major roads like Golf Course Road, NH-8, and the Rapid Metro are nearby, making travel quick and easy.",
      ],
      keywordLinks: {
        "pridepurple": "/developers/pridepurple",
      },
      image: overviewImageprojectthree,
      buttonLabel: "Enquire Now",
      stripdata: [
        {
          iconClass: locationiconprojectthree,
          title: "₹ 6.14 Crore Onwards ",
          subtitle: "Starting Price",
        },
        {
          iconClass: caliconprojectthree,
          title: "20:40:40",
          subtitle: "Payment Plan",
        },
        {
          iconClass: newlaunchiconprojectthree,
          title: "New Launch ",
          subtitle: "Status",
        },
      ],
    },

    pricing: {
      heading: "Pricing",
      table: [
        {
          type: "3 BHK ",
          area: "3000 sq.ft.",
          price: "₹ 6.14 Cr",
          eoiAmount: "On Request",
        },
        {
          type: "4 BHK  ",
          area: "3600 sq.ft. ",
          price: "₹ 7.37 Cr",
          eoiAmount: "On Request",
        },
      ],
    },

    floor_plan: [
      {
        type: "3 BHK ",
        area: "3000 sq.ft.",
        price: "₹ 6.14 Cr",
        image: floorplan1projectthree,
      },
      {
        type: "4 BHK  ",
        area: "3600 sq.ft. ",
        price: "₹ 7.37 Cr",
        image: floorplan2projectthree,
      }
    ],

    highlights: {
      images: Hightlightsprojectthree,
      tagline: "Highlights",
      features: [
        "540 EXCLUSIVE Units. ",
        "Over 80% of green space. ",
        "Stilt + 45 Storey Towers. ",
        "VRV / VRF Air-Conditioning & Modular Kitche. ",
        "Basement Entrance Lobby with Green Atrium. ",
        "Two Car Parkings Per Unit. ",
        "Over 1 lakh sq. ft. of amenities space. ",
      ],
    },

    location: {
      image: Locationprojectthree,
      data: [
        {
          airport: {
            distance_time: "24 km",
            name: "IGI Airport"
          },
          school: {
            distance_time: "1 Km",
            name: "GD Goenka School"
          },
          railwayormetro: {
            distance_time: "6 Km",
            name: "Millennium City Centre Gurugram"
          },
          hospital: {
            distance_time: "1 Km",
            name: "Park Hospital"
          },
          mall: {
            distance_time: "7 Km",
            name: "Airia Mall"
          }
        }
      ]
    },

    gallery: {
      color: "#cd8c66",
      tagline: "Project Gallery",
      images: [
        { image: gallery1projectthree },
        { image: gallery2projectthree },
        { image: gallery3projectthree },
        { image: gallery4projectthree },
        { image: gallery5projectthree },
      ],
    },

    whatsapp: {
      title: "Property Station",
      subTitle: "Happy to Help You!",
      greetingText: "Hi there! \nHow can I help you?",
      ctaText: "Start Chat",
      whatsAppNumber: "7079429676",
      welcomeMessage:
        "Hi! I'm interested in pridepurple The Trillion, kindly share more details.",
    },

    faq: [
      {
        question: "Where is pridepurple The Trillion located?",
        answer: `pridepurple The Trillion is located in Sector 48, Gurgaon, providing excellent connectivity to major business hubs and city landmarks.`,
      },
      {
        question: "What types of homes are available at pridepurple The Trillion?",
        answer: `pridepurple The Trillion offers spacious 3 BHK and 4 BHK luxury apartments designed for premium living.`,
      },
      {
        question: "What is the size range of apartments in pridepurple The Trillion?",
        answer: `The 3 BHK apartments are approximately 2850 sq. ft., and the 4 BHK apartments are around 3600 sq. ft.`,
      },
      {
        question: "What is the price range for apartments at pridepurple The Trillion?",
        answer: `Prices start from ₹6.14 Crores onwards, depending on the unit size, floor, and view.`,
      },
      {
        question: "Is the project RERA registered?",
        answer: `Yes, pridepurple The Trillion is RERA registered.`,
      },
      {
        question: "What is the possession status of pridepurple The Trillion?",
        answer: `The project is newly launched.`,
      },
      {
        question: "What amenities are offered at pridepurple The Trillion?",
        answer: `Amenities include a grand clubhouse, swimming pool, gym, spa, kids’ play area, jogging track, and landscaped gardens.`,
      },
      {
        question: "Who is the developer of pridepurple The Trillion?",
        answer: `pridepurple The Trillion is developed by pridepurple Developers, one of India's most trusted and reputed real estate developers, known for quality and innovation.`,
      },
      {
        question: "Is pridepurple The Trillion a good investment in Gurgaon?",
        answer: `Yes, with its prime location, luxury features, and strong brand reputation, pridepurple The Trillion is considered an excellent investment option in Gurgaon.`,
      },
      {
        question: "How is the connectivity from pridepurple The Trillion?",
        answer: `The project enjoys superb connectivity via Golf Course Extension Road and NH-8, offering easy access to major business centers and important city locations.`,
      }
    ],


    form_data: {
      api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
      api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
      source_id: 11,
      sub_source_id: 130,
      builder_id: `103`,
      project_id: `477`,
      subject: "Property Station enquiry", // Add or update the subject here
      to_email: "leads@gurugram-property.com",
    },
  },
  projectfour: {
    bannerdata: {
      bannerDesktopImage: bannerDesktopImageprojectfour,
      bannerMobileImage: bannerMobileImageprojectfour,
      textOverlay: "",
      data: {
        title: "pridepurple The Trillion",
        subtitle: " Sector 48, Gurugram",
        starting_price: "₹ 6.14 Crore Onwards  ",
        payment_plan: "20:40:40",
        rerano: "GGM/911/643/2025/14",
        status: "New Launch"
      }
    },

    overview: {
      heading: "pridepurple The Trillion",
      description: [
        "pridepurple The Trillion in Gurgaon is a new luxury residential project that offers a stylish and comfortable lifestyle. This residential project is located in Sector 48, Golf Course Extension Road, this project is designed for people who want a modern home with top-class features. It is developed by pridepurple Developers, The Trillion brings a perfect mix of beautiful design, world-class amenities, and a prime location.",
        "The project offers spacious 3 BHK, 4 BHK apartments, and penthouses with smart layouts and premium interiors. Every home at pridepurple Trillion is made to give you more space, natural light, and a peaceful environment. High-quality materials, smart home features, and luxury fittings make each apartment truly special.",
        "Living at pridepurple Trillion Sector 48 Gurgaon means enjoying a lot of premium facilities. There is a modern clubhouse, swimming pool, gym, spa, private dining spaces, children’s play area, and beautiful green gardens. You also get 24x7 security, concierge services, and easy access to all daily needs.",
        "The location of pridepurple The Trillion is one of its biggest advantages. It is close to important offices, schools, hospitals, malls, and restaurants. Major roads like Golf Course Road, NH-8, and the Rapid Metro are nearby, making travel quick and easy.",
      ],
      keywordLinks: {
        "pridepurple": "/developers/pridepurple",
      },
      image: overviewImageprojectfour,
      buttonLabel: "Enquire Now",
      stripdata: [
        {
          iconClass: locationiconprojectfour,
          title: "₹ 6.14 Crore Onwards ",
          subtitle: "Starting Price",
        },
        {
          iconClass: caliconprojectfour,
          title: "20:40:40",
          subtitle: "Payment Plan",
        },
        {
          iconClass: newlaunchiconprojectfour,
          title: "New Launch ",
          subtitle: "Status",
        },
      ],
    },

    pricing: {
      heading: "Pricing",
      table: [
        {
          type: "3 BHK ",
          area: "3000 sq.ft.",
          price: "₹ 6.14 Cr",
          eoiAmount: "On Request",
        },
        {
          type: "4 BHK  ",
          area: "3600 sq.ft. ",
          price: "₹ 7.37 Cr",
          eoiAmount: "On Request",
        },
      ],
    },

    floor_plan: [
      {
        type: "3 BHK ",
        area: "3000 sq.ft.",
        price: "₹ 6.14 Cr",
        image: floorplan1projectfour,
      },
      {
        type: "4 BHK  ",
        area: "3600 sq.ft. ",
        price: "₹ 7.37 Cr",
        image: floorplan2projectfour,
      }
    ],

    highlights: {
      images: Hightlightsprojectfour,
      tagline: "Highlights",
      features: [
        "540 EXCLUSIVE Units. ",
        "Over 80% of green space. ",
        "Stilt + 45 Storey Towers. ",
        "VRV / VRF Air-Conditioning & Modular Kitche. ",
        "Basement Entrance Lobby with Green Atrium. ",
        "Two Car Parkings Per Unit. ",
        "Over 1 lakh sq. ft. of amenities space. ",
      ],
    },

    location: {
      image: Locationprojectfour,
      data: [
        {
          airport: {
            distance_time: "24 km",
            name: "IGI Airport"
          },
          school: {
            distance_time: "1 Km",
            name: "GD Goenka School"
          },
          railwayormetro: {
            distance_time: "6 Km",
            name: "Millennium City Centre Gurugram"
          },
          hospital: {
            distance_time: "1 Km",
            name: "Park Hospital"
          },
          mall: {
            distance_time: "7 Km",
            name: "Airia Mall"
          }
        }
      ]
    },

    gallery: {
      color: "#cd8c66",
      tagline: "Project Gallery",
      images: [
        { image: gallery1projectfour },
        { image: gallery2projectfour },
        { image: gallery3projectfour },
        { image: gallery4projectfour },
        { image: gallery5projectfour },
      ],
    },

    whatsapp: {
      title: "Property Station",
      subTitle: "Happy to Help You!",
      greetingText: "Hi there! \nHow can I help you?",
      ctaText: "Start Chat",
      whatsAppNumber: "7079429676",
      welcomeMessage:
        "Hi! I'm interested in pridepurple The Trillion, kindly share more details.",
    },

    faq: [
      {
        question: "Where is pridepurple The Trillion located?",
        answer: `pridepurple The Trillion is located in Sector 48, Gurgaon, providing excellent connectivity to major business hubs and city landmarks.`,
      },
      {
        question: "What types of homes are available at pridepurple The Trillion?",
        answer: `pridepurple The Trillion offers spacious 3 BHK and 4 BHK luxury apartments designed for premium living.`,
      },
      {
        question: "What is the size range of apartments in pridepurple The Trillion?",
        answer: `The 3 BHK apartments are approximately 2850 sq. ft., and the 4 BHK apartments are around 3600 sq. ft.`,
      },
      {
        question: "What is the price range for apartments at pridepurple The Trillion?",
        answer: `Prices start from ₹6.14 Crores onwards, depending on the unit size, floor, and view.`,
      },
      {
        question: "Is the project RERA registered?",
        answer: `Yes, pridepurple The Trillion is RERA registered.`,
      },
      {
        question: "What is the possession status of pridepurple The Trillion?",
        answer: `The project is newly launched.`,
      },
      {
        question: "What amenities are offered at pridepurple The Trillion?",
        answer: `Amenities include a grand clubhouse, swimming pool, gym, spa, kids’ play area, jogging track, and landscaped gardens.`,
      },
      {
        question: "Who is the developer of pridepurple The Trillion?",
        answer: `pridepurple The Trillion is developed by pridepurple Developers, one of India's most trusted and reputed real estate developers, known for quality and innovation.`,
      },
      {
        question: "Is pridepurple The Trillion a good investment in Gurgaon?",
        answer: `Yes, with its prime location, luxury features, and strong brand reputation, pridepurple The Trillion is considered an excellent investment option in Gurgaon.`,
      },
      {
        question: "How is the connectivity from pridepurple The Trillion?",
        answer: `The project enjoys superb connectivity via Golf Course Extension Road and NH-8, offering easy access to major business centers and important city locations.`,
      }
    ],


    form_data: {
      api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
      api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
      source_id: 11,
      sub_source_id: 130,
      builder_id: `103`,
      project_id: `477`,
      subject: "Property Station enquiry", // Add or update the subject here
      to_email: "leads@gurugram-property.com",
    },
  },
  projectfive: {
    bannerdata: {
      bannerDesktopImage: bannerDesktopImageprojectfive,
      bannerMobileImage: bannerMobileImageprojectfive,
      textOverlay: "",
      data: {
        title: "pridepurple The Trillion",
        subtitle: " Sector 48, Gurugram",
        starting_price: "₹ 6.14 Crore Onwards  ",
        payment_plan: "20:40:40",
        rerano: "GGM/911/643/2025/14",
        status: "New Launch"
      }
    },

    overview: {
      heading: "pridepurple The Trillion",
      description: [
        "pridepurple The Trillion in Gurgaon is a new luxury residential project that offers a stylish and comfortable lifestyle. This residential project is located in Sector 48, Golf Course Extension Road, this project is designed for people who want a modern home with top-class features. It is developed by pridepurple Developers, The Trillion brings a perfect mix of beautiful design, world-class amenities, and a prime location.",
        "The project offers spacious 3 BHK, 4 BHK apartments, and penthouses with smart layouts and premium interiors. Every home at pridepurple Trillion is made to give you more space, natural light, and a peaceful environment. High-quality materials, smart home features, and luxury fittings make each apartment truly special.",
        "Living at pridepurple Trillion Sector 48 Gurgaon means enjoying a lot of premium facilities. There is a modern clubhouse, swimming pool, gym, spa, private dining spaces, children’s play area, and beautiful green gardens. You also get 24x7 security, concierge services, and easy access to all daily needs.",
        "The location of pridepurple The Trillion is one of its biggest advantages. It is close to important offices, schools, hospitals, malls, and restaurants. Major roads like Golf Course Road, NH-8, and the Rapid Metro are nearby, making travel quick and easy.",
      ],
      keywordLinks: {
        "pridepurple": "/developers/pridepurple",
      },
      image: overviewImageprojectfive,
      buttonLabel: "Enquire Now",
      stripdata: [
        {
          iconClass: locationiconprojectfive,
          title: "₹ 6.14 Crore Onwards ",
          subtitle: "Starting Price",
        },
        {
          iconClass: caliconprojectfive,
          title: "20:40:40",
          subtitle: "Payment Plan",
        },
        {
          iconClass: newlaunchiconprojectfive,
          title: "New Launch ",
          subtitle: "Status",
        },
      ],
    },

    pricing: {
      heading: "Pricing",
      table: [
        {
          type: "3 BHK ",
          area: "3000 sq.ft.",
          price: "₹ 6.14 Cr",
          eoiAmount: "On Request",
        },
        {
          type: "4 BHK  ",
          area: "3600 sq.ft. ",
          price: "₹ 7.37 Cr",
          eoiAmount: "On Request",
        },
      ],
    },

    floor_plan: [
      {
        type: "3 BHK ",
        area: "3000 sq.ft.",
        price: "₹ 6.14 Cr",
        image: floorplan1projectfive,
      },
      {
        type: "4 BHK  ",
        area: "3600 sq.ft. ",
        price: "₹ 7.37 Cr",
        image: floorplan2projectfive,
      }
    ],

    highlights: {
      images: Hightlightsprojectfive,
      tagline: "Highlights",
      features: [
        "540 EXCLUSIVE Units. ",
        "Over 80% of green space. ",
        "Stilt + 45 Storey Towers. ",
        "VRV / VRF Air-Conditioning & Modular Kitche. ",
        "Basement Entrance Lobby with Green Atrium. ",
        "Two Car Parkings Per Unit. ",
        "Over 1 lakh sq. ft. of amenities space. ",
      ],
    },

    location: {
      image: Locationprojectfive,
      data: [
        {
          airport: {
            distance_time: "24 km",
            name: "IGI Airport"
          },
          school: {
            distance_time: "1 Km",
            name: "GD Goenka School"
          },
          railwayormetro: {
            distance_time: "6 Km",
            name: "Millennium City Centre Gurugram"
          },
          hospital: {
            distance_time: "1 Km",
            name: "Park Hospital"
          },
          mall: {
            distance_time: "7 Km",
            name: "Airia Mall"
          }
        }
      ]
    },

    gallery: {
      color: "#cd8c66",
      tagline: "Project Gallery",
      images: [
        { image: gallery1projectfive },
        { image: gallery2projectfive },
        { image: gallery3projectfive },
        { image: gallery4projectfive },
        { image: gallery5projectfive },
      ],
    },

    whatsapp: {
      title: "Property Station",
      subTitle: "Happy to Help You!",
      greetingText: "Hi there! \nHow can I help you?",
      ctaText: "Start Chat",
      whatsAppNumber: "7079429676",
      welcomeMessage:
        "Hi! I'm interested in pridepurple The Trillion, kindly share more details.",
    },

    faq: [
      {
        question: "Where is pridepurple The Trillion located?",
        answer: `pridepurple The Trillion is located in Sector 48, Gurgaon, providing excellent connectivity to major business hubs and city landmarks.`,
      },
      {
        question: "What types of homes are available at pridepurple The Trillion?",
        answer: `pridepurple The Trillion offers spacious 3 BHK and 4 BHK luxury apartments designed for premium living.`,
      },
      {
        question: "What is the size range of apartments in pridepurple The Trillion?",
        answer: `The 3 BHK apartments are approximately 2850 sq. ft., and the 4 BHK apartments are around 3600 sq. ft.`,
      },
      {
        question: "What is the price range for apartments at pridepurple The Trillion?",
        answer: `Prices start from ₹6.14 Crores onwards, depending on the unit size, floor, and view.`,
      },
      {
        question: "Is the project RERA registered?",
        answer: `Yes, pridepurple The Trillion is RERA registered.`,
      },
      {
        question: "What is the possession status of pridepurple The Trillion?",
        answer: `The project is newly launched.`,
      },
      {
        question: "What amenities are offered at pridepurple The Trillion?",
        answer: `Amenities include a grand clubhouse, swimming pool, gym, spa, kids’ play area, jogging track, and landscaped gardens.`,
      },
      {
        question: "Who is the developer of pridepurple The Trillion?",
        answer: `pridepurple The Trillion is developed by pridepurple Developers, one of India's most trusted and reputed real estate developers, known for quality and innovation.`,
      },
      {
        question: "Is pridepurple The Trillion a good investment in Gurgaon?",
        answer: `Yes, with its prime location, luxury features, and strong brand reputation, pridepurple The Trillion is considered an excellent investment option in Gurgaon.`,
      },
      {
        question: "How is the connectivity from pridepurple The Trillion?",
        answer: `The project enjoys superb connectivity via Golf Course Extension Road and NH-8, offering easy access to major business centers and important city locations.`,
      }
    ],


    form_data: {
      api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
      api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
      source_id: 11,
      sub_source_id: 130,
      builder_id: `103`,
      project_id: `477`,
      subject: "Property Station enquiry", // Add or update the subject here
      to_email: "leads@gurugram-property.com",
    },
  },
  projectsix: {
    bannerdata: {
      bannerDesktopImage: bannerDesktopImageprojectsix,
      bannerMobileImage: bannerMobileImageprojectsix,
      textOverlay: "",
      data: {
        title: "pridepurple The Trillion",
        subtitle: " Sector 48, Gurugram",
        starting_price: "₹ 6.14 Crore Onwards  ",
        payment_plan: "20:40:40",
        rerano: "GGM/911/643/2025/14",
        status: "New Launch"
      }
    },

    overview: {
      heading: "pridepurple The Trillion",
      description: [
        "pridepurple The Trillion in Gurgaon is a new luxury residential project that offers a stylish and comfortable lifestyle. This residential project is located in Sector 48, Golf Course Extension Road, this project is designed for people who want a modern home with top-class features. It is developed by pridepurple Developers, The Trillion brings a perfect mix of beautiful design, world-class amenities, and a prime location.",
        "The project offers spacious 3 BHK, 4 BHK apartments, and penthouses with smart layouts and premium interiors. Every home at pridepurple Trillion is made to give you more space, natural light, and a peaceful environment. High-quality materials, smart home features, and luxury fittings make each apartment truly special.",
        "Living at pridepurple Trillion Sector 48 Gurgaon means enjoying a lot of premium facilities. There is a modern clubhouse, swimming pool, gym, spa, private dining spaces, children’s play area, and beautiful green gardens. You also get 24x7 security, concierge services, and easy access to all daily needs.",
        "The location of pridepurple The Trillion is one of its biggest advantages. It is close to important offices, schools, hospitals, malls, and restaurants. Major roads like Golf Course Road, NH-8, and the Rapid Metro are nearby, making travel quick and easy.",
      ],
      keywordLinks: {
        "pridepurple": "/developers/pridepurple",
      },
      image: overviewImageprojectsix,
      buttonLabel: "Enquire Now",
      stripdata: [
        {
          iconClass: locationiconprojectsix,
          title: "₹ 6.14 Crore Onwards ",
          subtitle: "Starting Price",
        },
        {
          iconClass: caliconprojectsix,
          title: "20:40:40",
          subtitle: "Payment Plan",
        },
        {
          iconClass: newlaunchiconprojectsix,
          title: "New Launch ",
          subtitle: "Status",
        },
      ],
    },

    pricing: {
      heading: "Pricing",
      table: [
        {
          type: "3 BHK ",
          area: "3000 sq.ft.",
          price: "₹ 6.14 Cr",
          eoiAmount: "On Request",
        },
        {
          type: "4 BHK  ",
          area: "3600 sq.ft. ",
          price: "₹ 7.37 Cr",
          eoiAmount: "On Request",
        },
      ],
    },

    floor_plan: [
      {
        type: "3 BHK ",
        area: "3000 sq.ft.",
        price: "₹ 6.14 Cr",
        image: floorplan1projectsix,
      },
      {
        type: "4 BHK  ",
        area: "3600 sq.ft. ",
        price: "₹ 7.37 Cr",
        image: floorplan2projectsix,
      }
    ],

    highlights: {
      images: Hightlightsprojectsix,
      tagline: "Highlights",
      features: [
        "540 EXCLUSIVE Units. ",
        "Over 80% of green space. ",
        "Stilt + 45 Storey Towers. ",
        "VRV / VRF Air-Conditioning & Modular Kitche. ",
        "Basement Entrance Lobby with Green Atrium. ",
        "Two Car Parkings Per Unit. ",
        "Over 1 lakh sq. ft. of amenities space. ",
      ],
    },

    location: {
      image: Locationprojectsix,
      data: [
        {
          airport: {
            distance_time: "24 km",
            name: "IGI Airport"
          },
          school: {
            distance_time: "1 Km",
            name: "GD Goenka School"
          },
          railwayormetro: {
            distance_time: "6 Km",
            name: "Millennium City Centre Gurugram"
          },
          hospital: {
            distance_time: "1 Km",
            name: "Park Hospital"
          },
          mall: {
            distance_time: "7 Km",
            name: "Airia Mall"
          }
        }
      ]
    },

    gallery: {
      color: "#cd8c66",
      tagline: "Project Gallery",
      images: [
        { image: gallery1projectsix },
        { image: gallery2projectsix },
        { image: gallery3projectsix },
        { image: gallery4projectsix },
        { image: gallery5projectsix },
      ],
    },

    whatsapp: {
      title: "Property Station",
      subTitle: "Happy to Help You!",
      greetingText: "Hi there! \nHow can I help you?",
      ctaText: "Start Chat",
      whatsAppNumber: "7079429676",
      welcomeMessage:
        "Hi! I'm interested in pridepurple The Trillion, kindly share more details.",
    },

    faq: [
      {
        question: "Where is pridepurple The Trillion located?",
        answer: `pridepurple The Trillion is located in Sector 48, Gurgaon, providing excellent connectivity to major business hubs and city landmarks.`,
      },
      {
        question: "What types of homes are available at pridepurple The Trillion?",
        answer: `pridepurple The Trillion offers spacious 3 BHK and 4 BHK luxury apartments designed for premium living.`,
      },
      {
        question: "What is the size range of apartments in pridepurple The Trillion?",
        answer: `The 3 BHK apartments are approximately 2850 sq. ft., and the 4 BHK apartments are around 3600 sq. ft.`,
      },
      {
        question: "What is the price range for apartments at pridepurple The Trillion?",
        answer: `Prices start from ₹6.14 Crores onwards, depending on the unit size, floor, and view.`,
      },
      {
        question: "Is the project RERA registered?",
        answer: `Yes, pridepurple The Trillion is RERA registered.`,
      },
      {
        question: "What is the possession status of pridepurple The Trillion?",
        answer: `The project is newly launched.`,
      },
      {
        question: "What amenities are offered at pridepurple The Trillion?",
        answer: `Amenities include a grand clubhouse, swimming pool, gym, spa, kids’ play area, jogging track, and landscaped gardens.`,
      },
      {
        question: "Who is the developer of pridepurple The Trillion?",
        answer: `pridepurple The Trillion is developed by pridepurple Developers, one of India's most trusted and reputed real estate developers, known for quality and innovation.`,
      },
      {
        question: "Is pridepurple The Trillion a good investment in Gurgaon?",
        answer: `Yes, with its prime location, luxury features, and strong brand reputation, pridepurple The Trillion is considered an excellent investment option in Gurgaon.`,
      },
      {
        question: "How is the connectivity from pridepurple The Trillion?",
        answer: `The project enjoys superb connectivity via Golf Course Extension Road and NH-8, offering easy access to major business centers and important city locations.`,
      }
    ],


    form_data: {
      api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
      api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
      source_id: 11,
      sub_source_id: 130,
      builder_id: `103`,
      project_id: `477`,
      subject: "Property Station enquiry", // Add or update the subject here
      to_email: "leads@gurugram-property.com",
    },
  },
  projectseven: {
    bannerdata: {
      bannerDesktopImage: bannerDesktopImageprojectseven,
      bannerMobileImage: bannerMobileImageprojectseven,
      textOverlay: "",
      data: {
        title: "pridepurple The Trillion",
        subtitle: " Sector 48, Gurugram",
        starting_price: "₹ 6.14 Crore Onwards  ",
        payment_plan: "20:40:40",
        rerano: "GGM/911/643/2025/14",
        status: "New Launch"
      }
    },

    overview: {
      heading: "pridepurple The Trillion",
      description: [
        "pridepurple The Trillion in Gurgaon is a new luxury residential project that offers a stylish and comfortable lifestyle. This residential project is located in Sector 48, Golf Course Extension Road, this project is designed for people who want a modern home with top-class features. It is developed by pridepurple Developers, The Trillion brings a perfect mix of beautiful design, world-class amenities, and a prime location.",
        "The project offers spacious 3 BHK, 4 BHK apartments, and penthouses with smart layouts and premium interiors. Every home at pridepurple Trillion is made to give you more space, natural light, and a peaceful environment. High-quality materials, smart home features, and luxury fittings make each apartment truly special.",
        "Living at pridepurple Trillion Sector 48 Gurgaon means enjoying a lot of premium facilities. There is a modern clubhouse, swimming pool, gym, spa, private dining spaces, children’s play area, and beautiful green gardens. You also get 24x7 security, concierge services, and easy access to all daily needs.",
        "The location of pridepurple The Trillion is one of its biggest advantages. It is close to important offices, schools, hospitals, malls, and restaurants. Major roads like Golf Course Road, NH-8, and the Rapid Metro are nearby, making travel quick and easy.",
      ],
      keywordLinks: {
        "pridepurple": "/developers/pridepurple",
      },
      image: overviewImageprojectseven,
      buttonLabel: "Enquire Now",
      stripdata: [
        {
          iconClass: locationiconprojectseven,
          title: "₹ 6.14 Crore Onwards ",
          subtitle: "Starting Price",
        },
        {
          iconClass: caliconprojectseven,
          title: "20:40:40",
          subtitle: "Payment Plan",
        },
        {
          iconClass: newlaunchiconprojectseven,
          title: "New Launch ",
          subtitle: "Status",
        },
      ],
    },

    pricing: {
      heading: "Pricing",
      table: [
        {
          type: "3 BHK ",
          area: "3000 sq.ft.",
          price: "₹ 6.14 Cr",
          eoiAmount: "On Request",
        },
        {
          type: "4 BHK  ",
          area: "3600 sq.ft. ",
          price: "₹ 7.37 Cr",
          eoiAmount: "On Request",
        },
      ],
    },

    floor_plan: [
      {
        type: "3 BHK ",
        area: "3000 sq.ft.",
        price: "₹ 6.14 Cr",
        image: floorplan1projectseven,
      },
      {
        type: "4 BHK  ",
        area: "3600 sq.ft. ",
        price: "₹ 7.37 Cr",
        image: floorplan2projectseven,
      }
    ],

    highlights: {
      images: Hightlightsprojectseven,
      tagline: "Highlights",
      features: [
        "540 EXCLUSIVE Units. ",
        "Over 80% of green space. ",
        "Stilt + 45 Storey Towers. ",
        "VRV / VRF Air-Conditioning & Modular Kitche. ",
        "Basement Entrance Lobby with Green Atrium. ",
        "Two Car Parkings Per Unit. ",
        "Over 1 lakh sq. ft. of amenities space. ",
      ],
    },

    location: {
      image: Locationprojectseven,
      data: [
        {
          airport: {
            distance_time: "24 km",
            name: "IGI Airport"
          },
          school: {
            distance_time: "1 Km",
            name: "GD Goenka School"
          },
          railwayormetro: {
            distance_time: "6 Km",
            name: "Millennium City Centre Gurugram"
          },
          hospital: {
            distance_time: "1 Km",
            name: "Park Hospital"
          },
          mall: {
            distance_time: "7 Km",
            name: "Airia Mall"
          }
        }
      ]
    },

    gallery: {
      color: "#cd8c66",
      tagline: "Project Gallery",
      images: [
        { image: gallery1projectseven },
        { image: gallery2projectseven },
        { image: gallery3projectseven },
        { image: gallery4projectseven },
        { image: gallery5projectseven },
      ],
    },

    whatsapp: {
      title: "Property Station",
      subTitle: "Happy to Help You!",
      greetingText: "Hi there! \nHow can I help you?",
      ctaText: "Start Chat",
      whatsAppNumber: "7079429676",
      welcomeMessage:
        "Hi! I'm interested in pridepurple The Trillion, kindly share more details.",
    },

    faq: [
      {
        question: "Where is pridepurple The Trillion located?",
        answer: `pridepurple The Trillion is located in Sector 48, Gurgaon, providing excellent connectivity to major business hubs and city landmarks.`,
      },
      {
        question: "What types of homes are available at pridepurple The Trillion?",
        answer: `pridepurple The Trillion offers spacious 3 BHK and 4 BHK luxury apartments designed for premium living.`,
      },
      {
        question: "What is the size range of apartments in pridepurple The Trillion?",
        answer: `The 3 BHK apartments are approximately 2850 sq. ft., and the 4 BHK apartments are around 3600 sq. ft.`,
      },
      {
        question: "What is the price range for apartments at pridepurple The Trillion?",
        answer: `Prices start from ₹6.14 Crores onwards, depending on the unit size, floor, and view.`,
      },
      {
        question: "Is the project RERA registered?",
        answer: `Yes, pridepurple The Trillion is RERA registered.`,
      },
      {
        question: "What is the possession status of pridepurple The Trillion?",
        answer: `The project is newly launched.`,
      },
      {
        question: "What amenities are offered at pridepurple The Trillion?",
        answer: `Amenities include a grand clubhouse, swimming pool, gym, spa, kids’ play area, jogging track, and landscaped gardens.`,
      },
      {
        question: "Who is the developer of pridepurple The Trillion?",
        answer: `pridepurple The Trillion is developed by pridepurple Developers, one of India's most trusted and reputed real estate developers, known for quality and innovation.`,
      },
      {
        question: "Is pridepurple The Trillion a good investment in Gurgaon?",
        answer: `Yes, with its prime location, luxury features, and strong brand reputation, pridepurple The Trillion is considered an excellent investment option in Gurgaon.`,
      },
      {
        question: "How is the connectivity from pridepurple The Trillion?",
        answer: `The project enjoys superb connectivity via Golf Course Extension Road and NH-8, offering easy access to major business centers and important city locations.`,
      }
    ],


    form_data: {
      api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
      api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
      source_id: 11,
      sub_source_id: 130,
      builder_id: `103`,
      project_id: `477`,
      subject: "Property Station enquiry", // Add or update the subject here
      to_email: "leads@gurugram-property.com",
    },
  },
  projecteight: {
    bannerdata: {
      bannerDesktopImage: bannerDesktopImageprojecteight,
      bannerMobileImage: bannerMobileImageprojecteight,
      textOverlay: "",
      data: {
        title: "pridepurple The Trillion",
        subtitle: " Sector 48, Gurugram",
        starting_price: "₹ 6.14 Crore Onwards  ",
        payment_plan: "20:40:40",
        rerano: "GGM/911/643/2025/14",
        status: "New Launch"
      }
    },

    overview: {
      heading: "pridepurple The Trillion",
      description: [
        "pridepurple The Trillion in Gurgaon is a new luxury residential project that offers a stylish and comfortable lifestyle. This residential project is located in Sector 48, Golf Course Extension Road, this project is designed for people who want a modern home with top-class features. It is developed by pridepurple Developers, The Trillion brings a perfect mix of beautiful design, world-class amenities, and a prime location.",
        "The project offers spacious 3 BHK, 4 BHK apartments, and penthouses with smart layouts and premium interiors. Every home at pridepurple Trillion is made to give you more space, natural light, and a peaceful environment. High-quality materials, smart home features, and luxury fittings make each apartment truly special.",
        "Living at pridepurple Trillion Sector 48 Gurgaon means enjoying a lot of premium facilities. There is a modern clubhouse, swimming pool, gym, spa, private dining spaces, children’s play area, and beautiful green gardens. You also get 24x7 security, concierge services, and easy access to all daily needs.",
        "The location of pridepurple The Trillion is one of its biggest advantages. It is close to important offices, schools, hospitals, malls, and restaurants. Major roads like Golf Course Road, NH-8, and the Rapid Metro are nearby, making travel quick and easy.",
      ],
      keywordLinks: {
        "pridepurple": "/developers/pridepurple",
      },
      image: overviewImageprojecteight,
      buttonLabel: "Enquire Now",
      stripdata: [
        {
          iconClass: locationiconprojecteight,
          title: "₹ 6.14 Crore Onwards ",
          subtitle: "Starting Price",
        },
        {
          iconClass: caliconprojecteight,
          title: "20:40:40",
          subtitle: "Payment Plan",
        },
        {
          iconClass: newlaunchiconprojecteight,
          title: "New Launch ",
          subtitle: "Status",
        },
      ],
    },

    pricing: {
      heading: "Pricing",
      table: [
        {
          type: "3 BHK ",
          area: "3000 sq.ft.",
          price: "₹ 6.14 Cr",
          eoiAmount: "On Request",
        },
        {
          type: "4 BHK  ",
          area: "3600 sq.ft. ",
          price: "₹ 7.37 Cr",
          eoiAmount: "On Request",
        },
      ],
    },

    floor_plan: [
      {
        type: "3 BHK ",
        area: "3000 sq.ft.",
        price: "₹ 6.14 Cr",
        image: floorplan1projecteight,
      },
      {
        type: "4 BHK  ",
        area: "3600 sq.ft. ",
        price: "₹ 7.37 Cr",
        image: floorplan2projecteight,
      }
    ],

    highlights: {
      images: Hightlightsprojecteight,
      tagline: "Highlights",
      features: [
        "540 EXCLUSIVE Units. ",
        "Over 80% of green space. ",
        "Stilt + 45 Storey Towers. ",
        "VRV / VRF Air-Conditioning & Modular Kitche. ",
        "Basement Entrance Lobby with Green Atrium. ",
        "Two Car Parkings Per Unit. ",
        "Over 1 lakh sq. ft. of amenities space. ",
      ],
    },

    location: {
      image: Locationprojecteight,
      data: [
        {
          airport: {
            distance_time: "24 km",
            name: "IGI Airport"
          },
          school: {
            distance_time: "1 Km",
            name: "GD Goenka School"
          },
          railwayormetro: {
            distance_time: "6 Km",
            name: "Millennium City Centre Gurugram"
          },
          hospital: {
            distance_time: "1 Km",
            name: "Park Hospital"
          },
          mall: {
            distance_time: "7 Km",
            name: "Airia Mall"
          }
        }
      ]
    },

    gallery: {
      color: "#cd8c66",
      tagline: "Project Gallery",
      images: [
        { image: gallery1projecteight },
        { image: gallery2projecteight },
        { image: gallery3projecteight },
        { image: gallery4projecteight },
        { image: gallery5projecteight },
      ],
    },

    whatsapp: {
      title: "Property Station",
      subTitle: "Happy to Help You!",
      greetingText: "Hi there! \nHow can I help you?",
      ctaText: "Start Chat",
      whatsAppNumber: "7079429676",
      welcomeMessage:
        "Hi! I'm interested in pridepurple The Trillion, kindly share more details.",
    },

    faq: [
      {
        question: "Where is pridepurple The Trillion located?",
        answer: `pridepurple The Trillion is located in Sector 48, Gurgaon, providing excellent connectivity to major business hubs and city landmarks.`,
      },
      {
        question: "What types of homes are available at pridepurple The Trillion?",
        answer: `pridepurple The Trillion offers spacious 3 BHK and 4 BHK luxury apartments designed for premium living.`,
      },
      {
        question: "What is the size range of apartments in pridepurple The Trillion?",
        answer: `The 3 BHK apartments are approximately 2850 sq. ft., and the 4 BHK apartments are around 3600 sq. ft.`,
      },
      {
        question: "What is the price range for apartments at pridepurple The Trillion?",
        answer: `Prices start from ₹6.14 Crores onwards, depending on the unit size, floor, and view.`,
      },
      {
        question: "Is the project RERA registered?",
        answer: `Yes, pridepurple The Trillion is RERA registered.`,
      },
      {
        question: "What is the possession status of pridepurple The Trillion?",
        answer: `The project is newly launched.`,
      },
      {
        question: "What amenities are offered at pridepurple The Trillion?",
        answer: `Amenities include a grand clubhouse, swimming pool, gym, spa, kids’ play area, jogging track, and landscaped gardens.`,
      },
      {
        question: "Who is the developer of pridepurple The Trillion?",
        answer: `pridepurple The Trillion is developed by pridepurple Developers, one of India's most trusted and reputed real estate developers, known for quality and innovation.`,
      },
      {
        question: "Is pridepurple The Trillion a good investment in Gurgaon?",
        answer: `Yes, with its prime location, luxury features, and strong brand reputation, pridepurple The Trillion is considered an excellent investment option in Gurgaon.`,
      },
      {
        question: "How is the connectivity from pridepurple The Trillion?",
        answer: `The project enjoys superb connectivity via Golf Course Extension Road and NH-8, offering easy access to major business centers and important city locations.`,
      }
    ],


    form_data: {
      api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
      api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
      source_id: 11,
      sub_source_id: 130,
      builder_id: `103`,
      project_id: `477`,
      subject: "Property Station enquiry", // Add or update the subject here
      to_email: "leads@gurugram-property.com",
    },
  },
  projectnine: {
    bannerdata: {
      bannerDesktopImage: bannerDesktopImageprojectnine,
      bannerMobileImage: bannerMobileImageprojectnine,
      textOverlay: "",
      data: {
        title: "pridepurple The Trillion",
        subtitle: " Sector 48, Gurugram",
        starting_price: "₹ 6.14 Crore Onwards  ",
        payment_plan: "20:40:40",
        rerano: "GGM/911/643/2025/14",
        status: "New Launch"
      }
    },

    overview: {
      heading: "pridepurple The Trillion",
      description: [
        "pridepurple The Trillion in Gurgaon is a new luxury residential project that offers a stylish and comfortable lifestyle. This residential project is located in Sector 48, Golf Course Extension Road, this project is designed for people who want a modern home with top-class features. It is developed by pridepurple Developers, The Trillion brings a perfect mix of beautiful design, world-class amenities, and a prime location.",
        "The project offers spacious 3 BHK, 4 BHK apartments, and penthouses with smart layouts and premium interiors. Every home at pridepurple Trillion is made to give you more space, natural light, and a peaceful environment. High-quality materials, smart home features, and luxury fittings make each apartment truly special.",
        "Living at pridepurple Trillion Sector 48 Gurgaon means enjoying a lot of premium facilities. There is a modern clubhouse, swimming pool, gym, spa, private dining spaces, children’s play area, and beautiful green gardens. You also get 24x7 security, concierge services, and easy access to all daily needs.",
        "The location of pridepurple The Trillion is one of its biggest advantages. It is close to important offices, schools, hospitals, malls, and restaurants. Major roads like Golf Course Road, NH-8, and the Rapid Metro are nearby, making travel quick and easy.",
      ],
      keywordLinks: {
        "pridepurple": "/developers/pridepurple",
      },
      image: overviewImageprojectnine,
      buttonLabel: "Enquire Now",
      stripdata: [
        {
          iconClass: locationiconprojectnine,
          title: "₹ 6.14 Crore Onwards ",
          subtitle: "Starting Price",
        },
        {
          iconClass: caliconprojectnine,
          title: "20:40:40",
          subtitle: "Payment Plan",
        },
        {
          iconClass: newlaunchiconprojectnine,
          title: "New Launch ",
          subtitle: "Status",
        },
      ],
    },

    pricing: {
      heading: "Pricing",
      table: [
        {
          type: "3 BHK ",
          area: "3000 sq.ft.",
          price: "₹ 6.14 Cr",
          eoiAmount: "On Request",
        },
        {
          type: "4 BHK  ",
          area: "3600 sq.ft. ",
          price: "₹ 7.37 Cr",
          eoiAmount: "On Request",
        },
      ],
    },

    floor_plan: [
      {
        type: "3 BHK ",
        area: "3000 sq.ft.",
        price: "₹ 6.14 Cr",
        image: floorplan1projectnine,
      },
      {
        type: "4 BHK  ",
        area: "3600 sq.ft. ",
        price: "₹ 7.37 Cr",
        image: floorplan2projectnine,
      }
    ],

    highlights: {
      images: Hightlightsprojectnine,
      tagline: "Highlights",
      features: [
        "540 EXCLUSIVE Units. ",
        "Over 80% of green space. ",
        "Stilt + 45 Storey Towers. ",
        "VRV / VRF Air-Conditioning & Modular Kitche. ",
        "Basement Entrance Lobby with Green Atrium. ",
        "Two Car Parkings Per Unit. ",
        "Over 1 lakh sq. ft. of amenities space. ",
      ],
    },

    location: {
      image: Locationprojectnine,
      data: [
        {
          airport: {
            distance_time: "24 km",
            name: "IGI Airport"
          },
          school: {
            distance_time: "1 Km",
            name: "GD Goenka School"
          },
          railwayormetro: {
            distance_time: "6 Km",
            name: "Millennium City Centre Gurugram"
          },
          hospital: {
            distance_time: "1 Km",
            name: "Park Hospital"
          },
          mall: {
            distance_time: "7 Km",
            name: "Airia Mall"
          }
        }
      ]
    },

    gallery: {
      color: "#cd8c66",
      tagline: "Project Gallery",
      images: [
        { image: gallery1projectnine },
        { image: gallery2projectnine },
        { image: gallery3projectnine },
        { image: gallery4projectnine },
        { image: gallery5projectnine },
      ],
    },

    whatsapp: {
      title: "Property Station",
      subTitle: "Happy to Help You!",
      greetingText: "Hi there! \nHow can I help you?",
      ctaText: "Start Chat",
      whatsAppNumber: "7079429676",
      welcomeMessage:
        "Hi! I'm interested in pridepurple The Trillion, kindly share more details.",
    },

    faq: [
      {
        question: "Where is pridepurple The Trillion located?",
        answer: `pridepurple The Trillion is located in Sector 48, Gurgaon, providing excellent connectivity to major business hubs and city landmarks.`,
      },
      {
        question: "What types of homes are available at pridepurple The Trillion?",
        answer: `pridepurple The Trillion offers spacious 3 BHK and 4 BHK luxury apartments designed for premium living.`,
      },
      {
        question: "What is the size range of apartments in pridepurple The Trillion?",
        answer: `The 3 BHK apartments are approximately 2850 sq. ft., and the 4 BHK apartments are around 3600 sq. ft.`,
      },
      {
        question: "What is the price range for apartments at pridepurple The Trillion?",
        answer: `Prices start from ₹6.14 Crores onwards, depending on the unit size, floor, and view.`,
      },
      {
        question: "Is the project RERA registered?",
        answer: `Yes, pridepurple The Trillion is RERA registered.`,
      },
      {
        question: "What is the possession status of pridepurple The Trillion?",
        answer: `The project is newly launched.`,
      },
      {
        question: "What amenities are offered at pridepurple The Trillion?",
        answer: `Amenities include a grand clubhouse, swimming pool, gym, spa, kids’ play area, jogging track, and landscaped gardens.`,
      },
      {
        question: "Who is the developer of pridepurple The Trillion?",
        answer: `pridepurple The Trillion is developed by pridepurple Developers, one of India's most trusted and reputed real estate developers, known for quality and innovation.`,
      },
      {
        question: "Is pridepurple The Trillion a good investment in Gurgaon?",
        answer: `Yes, with its prime location, luxury features, and strong brand reputation, pridepurple The Trillion is considered an excellent investment option in Gurgaon.`,
      },
      {
        question: "How is the connectivity from pridepurple The Trillion?",
        answer: `The project enjoys superb connectivity via Golf Course Extension Road and NH-8, offering easy access to major business centers and important city locations.`,
      }
    ],


    form_data: {
      api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
      api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
      source_id: 11,
      sub_source_id: 130,
      builder_id: `103`,
      project_id: `477`,
      subject: "Property Station enquiry", // Add or update the subject here
      to_email: "leads@gurugram-property.com",
    },
  },
  projectten: {
    bannerdata: {
      bannerDesktopImage: bannerDesktopImageprojectten,
      bannerMobileImage: bannerMobileImageprojectten,
      textOverlay: "",
      data: {
        title: "pridepurple The Trillion",
        subtitle: " Sector 48, Gurugram",
        starting_price: "₹ 6.14 Crore Onwards  ",
        payment_plan: "20:40:40",
        rerano: "GGM/911/643/2025/14",
        status: "New Launch"
      }
    },

    overview: {
      heading: "pridepurple The Trillion",
      description: [
        "pridepurple The Trillion in Gurgaon is a new luxury residential project that offers a stylish and comfortable lifestyle. This residential project is located in Sector 48, Golf Course Extension Road, this project is designed for people who want a modern home with top-class features. It is developed by pridepurple Developers, The Trillion brings a perfect mix of beautiful design, world-class amenities, and a prime location.",
        "The project offers spacious 3 BHK, 4 BHK apartments, and penthouses with smart layouts and premium interiors. Every home at pridepurple Trillion is made to give you more space, natural light, and a peaceful environment. High-quality materials, smart home features, and luxury fittings make each apartment truly special.",
        "Living at pridepurple Trillion Sector 48 Gurgaon means enjoying a lot of premium facilities. There is a modern clubhouse, swimming pool, gym, spa, private dining spaces, children’s play area, and beautiful green gardens. You also get 24x7 security, concierge services, and easy access to all daily needs.",
        "The location of pridepurple The Trillion is one of its biggest advantages. It is close to important offices, schools, hospitals, malls, and restaurants. Major roads like Golf Course Road, NH-8, and the Rapid Metro are nearby, making travel quick and easy.",
      ],
      keywordLinks: {
        "pridepurple": "/developers/pridepurple",
      },
      image: overviewImageprojectten,
      buttonLabel: "Enquire Now",
      stripdata: [
        {
          iconClass: locationiconprojectten,
          title: "₹ 6.14 Crore Onwards ",
          subtitle: "Starting Price",
        },
        {
          iconClass: caliconprojectten,
          title: "20:40:40",
          subtitle: "Payment Plan",
        },
        {
          iconClass: newlaunchiconprojectten,
          title: "New Launch ",
          subtitle: "Status",
        },
      ],
    },

    pricing: {
      heading: "Pricing",
      table: [
        {
          type: "3 BHK ",
          area: "3000 sq.ft.",
          price: "₹ 6.14 Cr",
          eoiAmount: "On Request",
        },
        {
          type: "4 BHK  ",
          area: "3600 sq.ft. ",
          price: "₹ 7.37 Cr",
          eoiAmount: "On Request",
        },
      ],
    },

    floor_plan: [
      {
        type: "3 BHK ",
        area: "3000 sq.ft.",
        price: "₹ 6.14 Cr",
        image: floorplan1projectten,
      },
      {
        type: "4 BHK  ",
        area: "3600 sq.ft. ",
        price: "₹ 7.37 Cr",
        image: floorplan2projectten,
      }
    ],

    highlights: {
      images: Hightlightsprojectten,
      tagline: "Highlights",
      features: [
        "540 EXCLUSIVE Units. ",
        "Over 80% of green space. ",
        "Stilt + 45 Storey Towers. ",
        "VRV / VRF Air-Conditioning & Modular Kitche. ",
        "Basement Entrance Lobby with Green Atrium. ",
        "Two Car Parkings Per Unit. ",
        "Over 1 lakh sq. ft. of amenities space. ",
      ],
    },

    location: {
      image: Locationprojectten,
      data: [
        {
          airport: {
            distance_time: "24 km",
            name: "IGI Airport"
          },
          school: {
            distance_time: "1 Km",
            name: "GD Goenka School"
          },
          railwayormetro: {
            distance_time: "6 Km",
            name: "Millennium City Centre Gurugram"
          },
          hospital: {
            distance_time: "1 Km",
            name: "Park Hospital"
          },
          mall: {
            distance_time: "7 Km",
            name: "Airia Mall"
          }
        }
      ]
    },

    gallery: {
      color: "#cd8c66",
      tagline: "Project Gallery",
      images: [
        { image: gallery1projectten },
        { image: gallery2projectten },
        { image: gallery3projectten },
        { image: gallery4projectten },
        { image: gallery5projectten },
      ],
    },

    whatsapp: {
      title: "Property Station",
      subTitle: "Happy to Help You!",
      greetingText: "Hi there! \nHow can I help you?",
      ctaText: "Start Chat",
      whatsAppNumber: "7079429676",
      welcomeMessage:
        "Hi! I'm interested in pridepurple The Trillion, kindly share more details.",
    },

    faq: [
      {
        question: "Where is pridepurple The Trillion located?",
        answer: `pridepurple The Trillion is located in Sector 48, Gurgaon, providing excellent connectivity to major business hubs and city landmarks.`,
      },
      {
        question: "What types of homes are available at pridepurple The Trillion?",
        answer: `pridepurple The Trillion offers spacious 3 BHK and 4 BHK luxury apartments designed for premium living.`,
      },
      {
        question: "What is the size range of apartments in pridepurple The Trillion?",
        answer: `The 3 BHK apartments are approximately 2850 sq. ft., and the 4 BHK apartments are around 3600 sq. ft.`,
      },
      {
        question: "What is the price range for apartments at pridepurple The Trillion?",
        answer: `Prices start from ₹6.14 Crores onwards, depending on the unit size, floor, and view.`,
      },
      {
        question: "Is the project RERA registered?",
        answer: `Yes, pridepurple The Trillion is RERA registered.`,
      },
      {
        question: "What is the possession status of pridepurple The Trillion?",
        answer: `The project is newly launched.`,
      },
      {
        question: "What amenities are offered at pridepurple The Trillion?",
        answer: `Amenities include a grand clubhouse, swimming pool, gym, spa, kids’ play area, jogging track, and landscaped gardens.`,
      },
      {
        question: "Who is the developer of pridepurple The Trillion?",
        answer: `pridepurple The Trillion is developed by pridepurple Developers, one of India's most trusted and reputed real estate developers, known for quality and innovation.`,
      },
      {
        question: "Is pridepurple The Trillion a good investment in Gurgaon?",
        answer: `Yes, with its prime location, luxury features, and strong brand reputation, pridepurple The Trillion is considered an excellent investment option in Gurgaon.`,
      },
      {
        question: "How is the connectivity from pridepurple The Trillion?",
        answer: `The project enjoys superb connectivity via Golf Course Extension Road and NH-8, offering easy access to major business centers and important city locations.`,
      }
    ],


    form_data: {
      api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
      api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
      source_id: 11,
      sub_source_id: 130,
      builder_id: `103`,
      project_id: `477`,
      subject: "Property Station enquiry", // Add or update the subject here
      to_email: "leads@gurugram-property.com",
    },
  },
};
